import { useLazyQuery } from '@apollo/client/react';
import { LoggerContextProps } from '../types/LogContext';
import { GET_USER } from '../queries/GetUser';
import { User } from '../types/User';
import { UseHookOptions } from '../types/UseHookOptions';
import { handleError } from './errorHandler';

export function useGetUser(options: UseHookOptions = {}) {
  const context: LoggerContextProps = {
    action: 'getUser',
  };
  const { useCache = true } = options;
  const [getUserQuery, { data, loading, error }] = useLazyQuery<{
    getUser: User;
  }>(GET_USER, {
    fetchPolicy: useCache ? 'cache-and-network' : 'network-only',
  });

  const getUser = async () => {
    try {
      await getUserQuery();
    } catch (error) {
      handleError(error, context, 'Failed to get user.');
    }
  };

  return { getUser, data, loading, error };
}
